import Swiper from 'swiper';
import {A11y, Navigation, Pagination, FreeMode, Thumbs} from 'swiper/modules';

window.Swiper = Swiper;



export function initSwiper() {
    // Общие параметры для всех слайдеров
    const commonOptions = {
        loop: true,
        autoplay: {
            delay: 3000,
        },
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    };

    // Инициализация всех слайдеров с базовыми параметрами
    const sliders = document.querySelectorAll('.swiper-container');

    sliders.forEach((slider) => {
        // Проверка типа элемента и приведение к HTMLElement
        if (slider instanceof HTMLElement) {
            // Уникальные параметры для каждого слайдера через класс
            let uniqueOptions = { ...commonOptions };

            if (slider.classList.contains('swiper-about')) {
                // Настройки для slider-1
                uniqueOptions = {
                    ...uniqueOptions,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 20,
                        },
                        991: {
                            slidesPerView: 2.4,
                            spaceBetween: 20,
                        }
                    },
                };
            }

            if (slider.classList.contains('swiper-business')) {
                // Настройки для slider-1
                uniqueOptions = {
                    ...uniqueOptions,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 3.5,
                            spaceBetween: 20,
                        },
                        991: {
                            slidesPerView: 5,
                            spaceBetween: 60,
                        },
                        1200: {
                            slidesPerView: 6,
                            spaceBetween: 80,
                        }
                    },
                };
            }

            if (slider.classList.contains('news-slider')) {
                // Настройки для slider-1
                uniqueOptions = {
                    ...uniqueOptions,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 60,
                        }
                    },
                };
            }

            // Инициализируем слайдер с уникальными параметрами
            new Swiper(slider, uniqueOptions);
        }
    });
}

